import React, { ReactNode, useState } from 'react';

import { ColorValue } from 'react-native';
import { RefreshControl as RefreshControlWeb } from 'react-native-web-refresh-control';

interface RefreshControl {
  onRefresh: () => Promise<void>;
  refreshing: boolean;
  children: ReactNode;
  tintColor?: ColorValue;
}

const RefreshControl = ({ onRefresh, refreshing, children, tintColor }: RefreshControl) => {
  const [loading, setLoading] = useState<boolean>(refreshing);

  async function handleRefresh() {
    setLoading(true);
    onRefresh().then(() => {
      setLoading(false);
    });
  }

  return (
    <RefreshControlWeb onRefresh={handleRefresh} refreshing={loading}>
      {children}
    </RefreshControlWeb>
  );
};

export default RefreshControl;
